import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GlobalErrorCapture } from "./components/GlobalErrorCapture";
// PWA disabled - service worker setup removed
// import { setupChunkErrorHandler } from "./lib/serviceWorker";
import { logBuildInfo } from "./lib/buildInfo";
import { initWebVitals } from "./lib/web-vitals";

// Log build version for debugging stale cache issues
logBuildInfo();

// PWA disabled - chunk error handler removed
// setupChunkErrorHandler();

// Initialize Web Vitals monitoring
initWebVitals({
  enableConsoleLogging: import.meta.env.DEV,
  enableAnalytics: !import.meta.env.DEV,
  enableSupabase: !import.meta.env.DEV,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Reduced staleTime to prevent stale data issues
      staleTime: 30 * 1000,            // 30 seconds (was 5 minutes)
      gcTime: 5 * 60 * 1000,           // 5 minutes
      refetchOnWindowFocus: true,      // Refetch when tab gains focus
      refetchOnMount: 'always',        // Always refetch on mount
      refetchOnReconnect: true,        // Refetch when back online
      retry: (failureCount, error: any) => {
        // Don't retry on RLS errors
        if (error?.code === '42P17') return false; // Infinite recursion
        if (error?.code === 'PGRST116') return false; // RLS violation
        return failureCount < 1;       // Single retry
      },
      retryDelay: 1000,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GlobalErrorCapture />
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
